export const initialState = {
  filtros: {
    paciente: "",
    mod: [],
    fechas: {
      inicio: "",
      final: "",
      ready: false
    }
  },
  ui: {
    drawer: { visible: false, componente: null },
    dialog: { visible: false, componente: 0 },
    herramientas: null
  },
  estudios: {
    items: [],
    cargando: true,
    sync: true,
    silentSync: false,
    error: false
  },
  configuracion: {
    autoSync: true,
  }
};

export function initMainState(defaultFechas) {
  let saved = window.sessionStorage.getItem("filtrosmain");
  let restored = null;
  if (saved) {
    try { 
      restored = JSON.parse(saved); 
    } catch (e) {
      console.warn("No se pudo leer sessionStorage", e);
    }
  }
  
  return {
    ...initialState,
    filtros: {
      paciente: restored?.paciente || "",
      mod: restored?.mod || [],
      fechas: restored?.fechas 
        ? { ...restored.fechas, ready: true } 
        : { ...defaultFechas, ready: true }
    },
    configuracion: {
      autoSync: restored?.autoSync !== undefined ? restored.autoSync : true
    }
  };
}

/**
 * @typedef {Object} MainAction
 * @property {string} type
 * @property {any} [payload]
 */

/**
 * @param {typeof initialState} state
 * @param {MainAction} action
 * @returns {typeof initialState}
 */
export function mainReducer(state, action) {
  switch (action.type) {
    case 'SET_FILTRO_PACIENTE':
      return { ...state, filtros: { ...state.filtros, paciente: action.payload } };
      
    case 'SET_FILTRO_MOD':
      return { ...state, filtros: { ...state.filtros, mod: action.payload } };
      
    case 'SET_FECHAS':
      return { 
        ...state, 
        filtros: { 
          ...state.filtros, 
          fechas: { ...state.filtros.fechas, inicio: action.payload.inicio, final: action.payload.final } 
        } 
      };
      
    case 'SET_DRAWER':
      return { ...state, ui: { ...state.ui, drawer: action.payload } };
      
    case 'SET_DIALOG':
      return { ...state, ui: { ...state.ui, dialog: action.payload } };
      
    case 'SET_HERRAMIENTAS':
      return { ...state, ui: { ...state.ui, herramientas: action.payload } };
      
    case 'SET_AUTOSYNC':
      return { ...state, configuracion: { ...state.configuracion, autoSync: action.payload } };
      
    case 'FETCH_START':
      return { ...state, estudios: { ...state.estudios, cargando: true, sync: true, items: [], error: false } };
      
    case 'SYNC_START':
      return { ...state, estudios: { ...state.estudios, sync: true } };
      
    case 'SILENT_SYNC_START':
      return { ...state, estudios: { ...state.estudios, silentSync: true, error: false } };
      
    case 'FETCH_SUCCESS':
      return { ...state, estudios: { ...state.estudios, cargando: false, sync: false, silentSync: false, items: action.payload, error: false } };
      
    case 'FETCH_ERROR':
      return { ...state, estudios: { ...state.estudios, cargando: false, sync: false, silentSync: false, error: true } };
      
    default:
      return state;
  }
}
